import { StyleSheet } from '@react-pdf/renderer';

export default StyleSheet.create({
  container: {
    margin: '10pt',
  },
  image: {},
});
